import classNames from 'classnames'
import { ICON_CHEVRON_LEFT_PRIMARY } from '../../../modules/svg/svg'

interface SliderPrevBtnProps {
  onClick?: () => void
  left?: string
  top?: string
  right?: string
}

const SliderPrevBtn = ({ onClick, left = '-6px', top = '50%', right = 'auto' }: SliderPrevBtnProps) => {
  return (
    <div
      className={classNames(
        onClick === null
          ? 'hidden'
          : 'absolute top-1/2 z-10 flex -translate-y-24 -translate-x-6 transform cursor-pointer items-center justify-center rounded-full bg-white shadow-md'
      )}
      style={{ width: '40px', height: '40px', left, top, right }}
      onClick={onClick}
    >
      <img src={ICON_CHEVRON_LEFT_PRIMARY} />
    </div>
  )
}

export default SliderPrevBtn
